export default "__VITE_ASSET__f0f093c9__"